import { useTranslation } from "react-i18next";
import StaffModal from "./StaffModal";

/** Resolve links against server-authorized data, never against a local branch ACL. */
export default function StaffRecordNotFound({onClose}:{onClose:()=>void}) {
  const {i18n}=useTranslation(),rtl=i18n.language==="ar";
  return <StaffModal onClose={onClose}>
    <h2>{rtl?"غير موجود":"Not found"}</h2>
    <div className="note bad" role="alert">{rtl?"هذا السجل غير موجود أو غير متاح ضمن صلاحياتك الحالية.":"This record does not exist or is not available in your current scope."}</div>
    <div className="foot"><button type="button" className="btn" onClick={onClose}>{rtl?"إغلاق":"Close"}</button></div>
  </StaffModal>;
}
